import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow4",
  "use": "icon-arrow4-usage",
  "viewBox": "0 0 8 4",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 4\" id=\"icon-arrow4\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.646.354a.5.5 0 0 1 .708 0l2.792 2.792A.5.5 0 0 1 6.793 4H1.207a.5.5 0 0 1-.353-.854L3.646.354Z\" fill=\"#7F8596\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol